import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import CategorySelector from './CategorySelector/CategorySelector'
import CollectionSelector from './CollectionSelector/CollectionSelector'
import { recommendationTypes } from './constants'
import { getRecommendationOptions, shouldRenderExchangeRecommendationSelector } from './helpers'
import * as Styles from './styles'

const ExchangeRecommendationTypeSelector = ({
  typeValue,
  onChangeType,
  onChangeValue,
  categories = [],
  collections = [],
  recommendationValue,
  provider,
  allowedPreferences,
  configurationPreferences,
  allowedExchangeMethods,
  externalConnectedGateway,
  availableRecommendationTypes,
  disabled,
}) => {
  const { t } = useTranslation()
  const handleChangeType = e => {
    const type = e.target.value
    let defaultValue = {
      [recommendationTypes.automatic]: '',
      [recommendationTypes.category]: categories[0]?.id,
      [recommendationTypes.collection]: collections[0]?.id,
    }

    onChangeType(e.target.value)
    onChangeValue(defaultValue[type])
  }

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    !shouldRenderExchangeRecommendationSelector({
      provider,
      configurationPreferences,
      allowedPreferences,
      allowedExchangeMethods,
      externalConnectedGateway,
    })
  ) {
    return null
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Recomendaciones de productos')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define qué recomendaciones de productos deben mostrarse a los clientes que solicitan un cambio por otro producto en el portal de devoluciones.'
        )}
      </Text>
      <div>
        <ComboBox
          label={t('Recomendar productos')}
          menuItems={getRecommendationOptions(availableRecommendationTypes, t)}
          value={typeValue}
          fullWidth
          handleChange={handleChangeType}
          disabled={disabled}
        />
        {typeValue === recommendationTypes.category && (
          <CategorySelector
            categories={categories}
            recommendationValue={recommendationValue}
            onChangeValue={onChangeValue}
            disabled={disabled}
          />
        )}
        {typeValue === recommendationTypes.collection && (
          <CollectionSelector
            collections={collections}
            recommendationValue={recommendationValue}
            onChangeValue={onChangeValue}
            disabled={disabled}
          />
        )}
      </div>
    </Styles.Container>
  )
}

export default ExchangeRecommendationTypeSelector
